export default __webpack_public_path__ + "static/media/partners3.703e2ade.jpg";